import { GAP_FRAMEWORK_CAPABILITIES } from './gapFrameworks';

// Map every route in your website to required capabilities
// Routes with empty arrays [] are public (no login required)
// Routes with capability names require those capabilities to access
// A nested array entry means ANY ONE of those capabilities is enough, e.g.
// [['A', 'B']] = A or B; ['A', ['B', 'C']] = A and (B or C).
// this is temp changes 
export const ROUTE_PERMISSIONS = {
  // === PUBLIC ROUTES (no login required) ===
  '/': [],
  '/login': [],
  '/cara_login': [],
  '/tprm_login': [],
  '/tprm_user_login': [],
  '/vrm_login': [],
  '/offsec_staff_login': [],
  '/superadmin_login': [],
  '/internal_staff_login': [],
  '/otp': [],
  '/ota': [],
  '/reset_password': [],
  // '/set_password': [], // Duplicate removed from line 38
  '/expired-link': [],
  '/book_demo': [],
  '/404': [],


  // === MISSING ROUTES (added for completeness) ===
  // TPRM Audit Trail page (CARA staff). Vendor admins use /audit_trail_user.
  '/audit_trail_users': ['TPRM Audit Trail'],
  '/audit_trail_user': ['Audit Trail'],
  '/audit_trails': ['Audit Trail'],
  '*': [], // Catch-all route
  '/superadmin_ask_the_expert': ['Chat Support'],
  '/superadmin_vrm_mapping': [],
  '/create_offsec_staff': [],
  '/superadmin_offsec_staff_mapping': [],

  // === BASE ROUTES (available to all logged-in users) ===
  '/assessment_dashboard': ['Assessments Dashboard'],
  '/profile': [],
  '/privacy': [],
  '/framework_and_standards': ['Frameworks & Standards'],
  '/archived_frameworks': [],
  '/custom_framework': ['Create your own Framework'],
  '/documentation': ['Documentation Generator'],
  '/document_vault': ['Document Vault'],
  '/policy_library': ['Policy Library'],
  '/tprm_question_bank': [],
  '/create_cara_self_user': [],
  // '/create_cara_admin': [],
  '/set_password': [], // Kept this one as it matches base routes grouping
  '/upgrade': [],
  '/edit_cara_self_user': [],
  '/external_auditor_dashboard': ['Audits Dashboard'],
  '/internal_auditor_dashboard': ['Audits Dashboard'],
  '/Edit_Third_Party_User': [],
  '/command_center': ['Command Center'],
  '/view_questionnaire': [],//kept for demo 136 line need proper capabilities
  '/asset_management': ['Asset Management'],
  '/process_management': ['Process Management'],
  '/asset_mapping': ['Asset Mapping'],
  '/risk_dashboard': ['Risk Dashboard'],
  '/regulatory_library/penalties': ['Penalties'],
  '/regulatory_library': ['Regulatory Library'],
  '/regulatory_tasks': [],
  '/tprm_support_requests': ['TPRM Support Requests'],
  // === OFFSEC ===
  // Each page needs the capability its API checks; the any-of groups mirror
  // the backend's require_permission fallbacks (api/domains/offsec/*/views.py).
  '/offsec_dashboard': ['OffSec Engagements'],
  '/offsec_service_requests': ['OffSec Service Requests'],
  '/offsec_service_requests/new': ['OffSec Service Requests'],
  '/offsec_engagements': ['OffSec Engagements'],
  '/offsec_findings': ['OffSec Findings'],
  '/offsec_remediation': [['OffSec Remediation', 'OffSec Findings']],
  '/offsec_revalidation': [['OffSec Revalidation', 'OffSec Findings']],
  '/offsec_reports': [['OffSec Reports', 'OffSec Engagements']],
  // '/offsec_administration': [],
  '/offsec_staff_dashboard': [],
  '/offsec_staff_settings': [],
  '/offsec_staff_findings': [],
  '/offsec_staff_overview': [],
  '/offsec_staff_engagements': [],
  '/offsec_staff_remediation': [],
  '/offsec_staff_revalidation': [],
  '/offsec_staff_reports': [],
  '/offsec_staff_schedule': [],
  '/offsec_staff_clients': [],
  '/offsec_staff_activity': [],




  //superadmin 
  '/create_super_admin': ['Create Super Admin'],
  '/policy_library_admin': ['Superadmin Dashboard'],
  '/superadmin_enquiries': ['Superadmin Enquiries'],
  '/superadmin_cyberinsurify_enquiries': ['Superadmin Enquiries'],
  '/superadmin_tenure_tracker': ['Tenure Tracker'],
  '/superadmin_announcements': ['Manage Announcements'],
  '/superadmin_create_package': ['Create Package'],
  '/superadmin_packages': ['Create Package'],
  '/create_cara_admin_v2': ['Create CARA Admin V2'],
  '/superadmin_vrm_utilization': ['Superadmin Dashboard'],


  //issue for frameworks
  // === FRAMEWORK ASSESSMENTS ===
  '/quantify_data_nist': ['CO NIST CSF 2.0 Assessment'],
  '/quantify_data_cara': ['CO NIST CSF 1.0 Assessment'],
  '/quantify_data_ransomware': ['CO NIST Ransomware Assessment'],
  '/nist_ai_framework': ['CO NIST AI RMF Assessment'],
  '/iso27001_framework': ['CO ISO 27001 Assessment'],
  '/cisv8_framework': ['CO CIS V8.1 Assessment'],
  '/rbi_csf_framework': ['CO RBI CSF Assessment'],

  // === VIEW ROUTES (Framework Views) ===
  '/view_nist_csf_2_0': ['NIST CSF 2.0 Assessment'],
  '/view_nist_csf_1_1': ['NIST CSF 1.0 Assessment'],
  '/view_rbi_cara': ['RBI CSF Assessment'],
  '/view_Iso_csf_cara': ['ISO 27001 Assessment'],
  '/view_cisv8_1': ['CIS V8.1 Assessment'],
  '/view_ransomware': ['NIST Ransomware Assessment'],
  '/view_nistai_rmf': ['NIST AI RMF Assessment'],
  '/view_smart_map': ['Smart Map'],

  // === DASHBOARDS ===
  '/tprm_dashboard': ['TPRM Dashboard'],
  '/tprm_admin_dashboard': ['TPRM Dashboard'],
  '/crq_dashboard': ['CRQ Dashboard'],
  '/crp_dashboard': ['Resilience Posture Dashboard'],
  '/entity_dashboard': ['TPRM Dashboard'],
  '/vrm_dashboard': ['VRM Dashboard'],
  '/vrm_client_dashboard': ['VRM Dashboard'],
  '/vrm_risk_register_requests': ['VRM Dashboard'],
  '/vrm_questionnaire_requests': ['VRM Dashboard'],
  '/vrm_custom_questionnaires': ['VRM Dashboard'],
  '/vrm_audit_checklist_requests': ['VRM Dashboard'],
  '/vrm_audit_buddy_requests': ['VRM Dashboard'],
  // VRM staff only - the CARA-user "Framework Requests" page was removed.
  '/vrm_framework_requests': [['VRM Dashboard', 'Framework Dashboard']],
  '/vrm_audit_trails': ['VRM Dashboard'],
  '/vrm_recommendations': ['VRM Dashboard'],
  '/admin_vrm_recommendations': ['Admin VRM Recommendations'],
  '/vrm_tracker': [],
  '/vrm_portfolio_dashboard': ['VRM Dashboard'],
  '/vrm_client_workspace': ['VRM Dashboard'],
  '/vrm_client_success_plan': ['VRM Dashboard'],
  '/vrm_time_logs': ['VRM Dashboard'],

  // === RISK MANAGEMENT ===
  '/risk_register': ['Enterprise Risk Register'],
  '/risk_register_tracker': ['Risk Register Tracker'],
  '/risk_report_builder': ['Report Builder'],
  '/risk_assessment': ['Risk Assessments'],
  '/risk_assesment_tracker': ['Risk Assessments Tracker'],
  '/add_risk_scenario': ['Enterprise Risk Register'],
  '/cis_risk_assessment': ['Risk Assessments'],
  '/isms_risk_assessment': ['Risk Assessments'],
  '/isms_risk_register': ['Risk Assessments'],
  '/cisv8_risk_register': ['CIS V8.1 Assessment'],

  // === AUDIT MANAGEMENT ===
  '/manage_audit': ['Manage Audits View'],
  '/audit_documents': ['Audit Document'],
  '/audit_tracker': ['Audit Tracker'],
  '/create_audit': ['Manage Audits View'],
  // '/external_auditor_dashboard': ['Manage Audits View'],
  // '/internal_auditor_dashboard': ['Manage Audits View'],

  // === AUDIT CHECKLISTS ===
  // Listing page: any checklist grant is enough (same set carausersidbar.js
  // uses to show the link); each card is still gated by hasChecklistAccess.
  '/audit_checklist': [['Audit Checklist', 'GDPR', 'Data Protection Act', 'ISO 27001',
    'Service Organization Control (SOC) 2', 'Cara Compliance and Risk Assessment',
    'Cara Ai Security', 'Inside Threat Defense', 'FATF Mutual Evaluation']],
  '/audit_checklist/:cid': ['Audit Checklist'],
  '/audit-buddy': ['Audit Checklist'],
  '/audit-buddy/generate': ['Audit Checklist'],
  '/boatswana_data_protection': ['Data Protection Act'], // Botswana Data Protection
  '/gdpr_audit_checklist': ['GDPR'],
  '/insider_threat_checklist': ['Inside Threat Defense'],
  '/business_continuity_checklist': ['Cara Compliance and Risk Assessment'],
  '/ai_weapons_checklist': ['Cara Ai Security'],
  '/soc2_checklist': ['Service Organization Control (SOC) 2'],
  '/iso_27001_checklist': ['ISO 27001'],
  '/fatf_checklist': ['FATF Mutual Evaluation'],

  // === TPRM (Third Party Risk Management) ===
  '/third_party_users': ['Third Party Users'],
  '/tprm_tracker': ['TPRM Tracker'],
  '/create_tprm_admin': ['Third Party Users'],
  '/assign_tprm_questionnaire': ['Third Party Users'],
  '/tprm_assessment': [['Third Party Users', 'TPRM Assessment']],
  '/create_tprm_user': ['Third Party Users'],
  '/view_tprm_questionnaire': ['TPRM Questionnaire'],
  '/tprm_questionnaire': ['TPRM Questionnaire'],
  '/tprm_v2_questionnaire': ['TPRM Questionnaire'],
  '/cara_tprm_user_details': ['CARA TPRM User Details'],
  //'/Edit_Third_Party_User': ['Edit Third Party User'],

  // === USER MANAGEMENT ===
  '/role_management': ['Roles Management'],
  '/my_users': ['My Users'],
  //'/edit_cara_self_user': ['Edit User'],
  '/department_management': ['Department Management'],
  //'/create_cara_self_user': ['Create User'],
  '/request_management': ['Request Management'],

  // === QUESTIONNAIRES ===
  // Shared page: linked from Risk Assessments and from the TPRM menu
  // (carausersidbar.js gates the TPRM link on the same TPRM strings below).
  '/questionnaire': [['Risk Assessments', 'Create your own Questionnaire', 'CyberFirst', 'CyberSolutions']],
  //'/view_questionnaire': ['View Questionnaire'],
  '/dynamic-questionnaire-generator': ['Dynamic Question Generator'],
  '/ai-questionnaire-generator': [['Risk Assessments', 'Create your own Questionnaire']],

  // === TRACKING & MONITORING ===
  '/progress_tracker': ['Progress Tracker'],
  '/evidence_tracker': ['Evidence Tracker'],
  '/compliance_tracker': ['Compliance Tracker'],
  // AI Gap & Risk Intelligence (backend also gates per tenant + gap_mgmt.* PBAC)
  // Any supported framework's card capability (config/gapFrameworks.js).
  '/gap_review': [GAP_FRAMEWORK_CAPABILITIES],
  '/gap_register': [GAP_FRAMEWORK_CAPABILITIES],
  '/gap_detail': [GAP_FRAMEWORK_CAPABILITIES],
  '/gap_new': [GAP_FRAMEWORK_CAPABILITIES],
  '/task_review': [GAP_FRAMEWORK_CAPABILITIES],
  '/action_tracker': [[...GAP_FRAMEWORK_CAPABILITIES, 'Risk Assessments']],
  '/framework_risk_review': ['Risk Assessments'],
  '/framework_risk_register': ['Risk Assessments'],
  '/framework_risk_detail': ['Risk Assessments'],
  '/nist_ai_compliance_tracker': ['NIST AI RMF Assessment'],

  // === CYBER SECURITY FEATURES ===
  '/cyber_resilience_posture': ['Cyber Resilience Posture'],
  '/cyber_risk_quantification': [],  // No specific capability required - available to all logged-in users
  '/threat_form': [],  // No specific capability required - available to all logged-in users
  '/instructions': [],  // No specific capability required - available to all logged-in users
  '/circuler_ref': [],  // No specific capability required - available to all logged-in users

  // === SUPPORT & COMMUNICATION ===
  '/ask_the_expert': ['Chat Support'],
  '/email_support': ['Email Support'],
  '/my_feedback': ['Feedback & Suggestions'],
  '/submit_feedback': ['Feedback & Suggestions'],
  '/announcement': ['Announcements'],
  '/contact_vrm': ['Contact VRM'],
  '/connect_with_vrm': ['Connect with VRM'],

  // === BUSINESS FEATURES ===
  '/cara_roi_quantifier': [],  // No specific capability required - available to all logged-in users
  '/smart_map_framework': ['Smart Map'],
  //'/upgrade': ['Upgrade'],
  '/ucb_contact': [],  // No specific capability required - available to all logged-in users

  // === ADMINISTRATIVE ===
  '/my_request': ['My Request'],
  '/create_cara_vrm': ['Create CARA VRM'],
  //'/create_cara_admin': ['Create CARA Admin'],
  '/cara_user_sidbar': ['CARA User Sidebar'],



  //superadmin
  '/superadmin_dashboard': ['Superadmin Dashboard'],
  '/create_internal_department': ['Create Internal Department'],
  '/internal_departments': ['View Internal Departments'],
  '/create_internal_role': ['Create Internal Role'],
  '/create_internal_staff': ['Create Internal Staff'],
  '/internal_staff': ['View Internal Staff'],


  '/internal_roles': ['View Internal Roles'],
  '/create_cara_admin': ['Create Admin'],
  '/create_cara_admin_v2': ['Create Admin'],
  '/superadmin_manage_admins': ['Create Admin'],
  '/edit_cara_admin': ['Create Admin'],
  '/view_cara_admin': ['Create Admin'],
  '/client_360': ['Create Admin'],
  '/superadmin_onboarding': ['Create Admin'],
  '/superadmin_storage': ['Storage Management'],
  '/superadmin_ai_usage': ['AI Usage & Limits'],
  '/superadmin_upgrade_requests': ['Superadmin Dashboard'],
  //'/create_super_admin': ['Superadmin Dashboard'],

  // === TESTING/DEBUG ROUTES ===
  '/example': [],
  '/compliance_tracker_framework': []
};

// Helper function to check if user has access to a route
export const hasRouteAccess = (routePath, userCapabilities = []) => {
  const requiredCapabilities = ROUTE_PERMISSIONS[routePath];

  console.log(`🔎 Checking access for route: ${routePath}`);
  console.log(` Required capabilities:`, requiredCapabilities);
  console.log(`👤 User capabilities (${userCapabilities.length}):`, userCapabilities);

  // If route is not in permissions map, DENY ACCESS (secure by default)
  if (requiredCapabilities === undefined) {
    console.log(`🚫 Route ${routePath} not in permissions map - DENIED`);
    return false;
  }

  // If no capabilities required, it's public
  if (requiredCapabilities.length === 0) {
    console.log(`🌐 Route ${routePath} is public - ALLOWED`);
    return true;
  }

  // Check if user has all required capabilities
  const hasAllCapabilities = requiredCapabilities.every(capability => {
    // A nested array is an any-of group.
    const hasCapability = Array.isArray(capability)
      ? capability.some(option => userCapabilities.includes(option))
      : userCapabilities.includes(capability);
    console.log(`   Checking "${capability}": ${hasCapability ? '' : ''}`);
    return hasCapability;
  });

  console.log(`🎯 Final result - Has all required capabilities: ${hasAllCapabilities}`);
  return hasAllCapabilities;
};

// Helper to get all routes that require a specific capability
export const getRoutesForCapability = (capability) => {
  return Object.entries(ROUTE_PERMISSIONS)
    .filter(([route, capabilities]) => capabilities.flat().includes(capability))
    .map(([route]) => route);
};

// Helper to get all capabilities required for a route
export const getCapabilitiesForRoute = (routePath) => {
  return ROUTE_PERMISSIONS[routePath] || [];
};
